import styled from "styled-components";

export const Wrapper = styled.div`
 
  span {
    margin-left: auto;
    display: flex;
  }
  button {
    margin-top: 1rem;
    margin-left: 1rem;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  .ghost-btn {
    background-color: transparent;
    color: ${({ theme }) => theme.default.color.primary};
    border: ${({ theme }) =>
    `1px solid ${theme.default.color.primary}`};
  }
`;
